module.exports = __webpack_public_path__ + "static/media/communal-lw.2fc987d7.png";